import {useTranslation} from 'react-i18next'
import {Label} from '@/components/ui/label'
import {Textarea} from '@/components/ui/textarea'
import {PersonPicker, type Person} from '@/components/person-picker'
import type {Employee} from '@/hooks/empresa/identidad/use-employees'
import {tope} from '@/lib/campos-texto'

export function AccionCommonFields({
  idPrefix,
  businessId,
  roster,
  description,
  onDescriptionChange,
  descripcionPlaceholder,
  person,
  onPersonChange,
  resources,
  onResourcesChange,
}: {
  idPrefix: string
  businessId: string
  roster: Employee[]
  description: string
  onDescriptionChange: (value: string) => void
  // Pista, nunca valor: el campo arranca vacío y `required` sigue impidiendo enviarlo así.
  descripcionPlaceholder?: string
  person: Person | null
  onPersonChange: (person: Person | null) => void
  resources: string
  onResourcesChange: (value: string) => void
}) {
  const {t} = useTranslation()
  return (
    <>
      <div className="space-y-2">
        <Label htmlFor={`${idPrefix}_description`}>{t('plan.form.description')}</Label>
        <Textarea
          id={`${idPrefix}_description`}
          value={description}
          onChange={(e) => onDescriptionChange(e.target.value)}
          placeholder={descripcionPlaceholder ?? t('plan.form.descriptionPlaceholder')}
          required
          maxLength={tope('NOTA')}
          minRows={3}
        />
      </div>
      <div className="space-y-2">
        <Label>
          {t('plan.form.responsible')} <span className="text-muted-foreground">{t('plan.form.requiredMark')}</span>
        </Label>
        <PersonPicker businessId={businessId} roster={roster} value={person} onChange={onPersonChange} />
      </div>
      <div className="space-y-2">
        <Label htmlFor={`${idPrefix}_resources`}>{t('plan.form.resources')}</Label>
        <Textarea
          id={`${idPrefix}_resources`}
          value={resources}
          maxLength={300}
          minRows={2}
          onChange={(e) => onResourcesChange(e.target.value)}
        />
      </div>
    </>
  )
}
